import { TextField, Grid, FormControl, InputLabel, Select, MenuItem, Button } from '@material-ui/core';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useStore } from 'hooks/useRootStore';
import React, { FC, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { InvitationFormProps } from '../../types';
import { InviteUsers } from '../types';
import { useStyles } from './styles';
import headerlogo from '../../../../../assets/icons/logo.svg';
import EmailHeader from 'components/EmailHeader/EmailHeader';
export const Manually: FC<InvitationFormProps> = ({ open, step, refetch, handleClose, emailtemps }) => {
  const [selected, setSelected] = useState<string>('register');
  const [registrationStep, setRegistrationStep] = useState(true);
  const [emails, setInvoiceEmail] = useState<string>('');
  const [valid, setValid] = useState<any>();
  const classes = useStyles();
  const handleValidation = (e: any) => {
    const reg = new RegExp(
      /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~`-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\s*,\s*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~`-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})*$/
    );
    setValid(reg.test(e.target.value));
    setInvoiceEmail(e.target.value);
  };
  const {
    invitationStore: { sendManualInvitation, sendManualInvitationStepone },
    emailTemplatesTableStore: { getEmail, emailtemp },
    notificationStore: { openNotification },
    appPreloaderStore: { setPreloaderState },
  } = useStore();
  const sendManualInvitationReq = useMutation((data: any) => sendManualInvitation(data), {
    mutationKey: 'sendManualInvitationReq',
    onSuccess: (e) => {
      openNotification('success', `${e}`);
      emailtemps(false);
      setPreloaderState(false, 'outside', 'big');
      handleClose();
    },
    onError: (e) => openNotification('error', `${e}`),
  });
  const sendManualInvitationSteponeReq = useMutation((data: any) => sendManualInvitationStepone(data, 'manually'), {
    mutationKey: 'sendManualInvitationSteponeReq',
    onSuccess: (e) => {
      setRegistrationStep(!registrationStep);
      emailtemps(registrationStep);
    },
    onError: (e) => {
      openNotification('error', `${e}`);
    },
  });

  const getEmailTemplateReq = useQuery('getEmailTemplateReq', () => getEmail(), {
    enabled: !registrationStep,
    onError: () => openNotification('error', `Can't get email template`),
  });
  step(registrationStep);
  const { control, handleSubmit } = useForm<InviteUsers>();
  useAppPreloader(sendManualInvitationReq.isLoading || getEmailTemplateReq.isLoading);
  const onSubmit = (data: InviteUsers) => {
    const arr: any[] = [];
    const invoicesData: string[] = emails.split(',');
    arr.push(invoicesData);
    const trimArray = arr.flat().map((element: any) => element.trim());
    const pass = {
      inviteType: (data.inviteType = selected),
      emails: (data.emails = trimArray && trimArray),
    };

    sendManualInvitationSteponeReq.mutate(pass);
  };
  const replaceTemplateVariables = (text: string) => {
    return text
      .replace(/{{user_firstname}}/g, 'Username')
      .replace(/{{user_lastname}}/g, 'user_lastname')
      .replace(/{{user_email}}/g, 'user_email')
      .replace(/{{organization_name}}/g, 'organization_name')
      .replace(/{{Admin_fullname}}/g, 'AdminFullname')
      .replace(/{{admin_org}}/g, 'AdminOrg')
      .replace(/{{admin_email}}/g, 'AdminEmail');
  };

  const onSubmit2 = (data: InviteUsers) => {
    const arr: any[] = [];
    const invoicesData: string[] = emails.split(',');
    arr.push(invoicesData);
    const trimArray = arr.flat().map((element: any) => element.trim());
    const ProfileData = { emails: trimArray && trimArray, inviteType: selected };
    let reg = {};
    if (selected === 'register') {
      reg = {
        ...ProfileData,
        templateSubject: data.templateSubjectReg,
        templateBody: data.templateBodyReg,
        inviteType: 'register',
        templateSignatureNameReg: data.templateSignatureNameReg,
        templateSignaturePositionReg: data.templateSignaturePositionReg,
      };
    } else {
      reg = {
        ...ProfileData,
        templateSubject: data.templateSubjectPass,
        templateBody: data.templateBodyPass,
        inviteType: 'password',
        templateSignatureName: data.templateSignatureNamePass,
        templateSignaturePosition: data.templateSignaturePositionPass,
      };
    }

    sendManualInvitationReq.mutate(reg);
  };
  return (
    <>
      {registrationStep === true ? (
        <form onSubmit={handleSubmit(onSubmit)} className={classes.formContainer}>
          <Controller
            name='inviteType'
            defaultValue='register'
            control={control}
            render={({ field, fieldState: { invalid } }) => (
              <Grid className={classes.row} container>
                <FormControl className={classes.input}>
                  <InputLabel>Invitation type :</InputLabel>
                  <Select
                    {...field}
                    error={invalid}
                    value={selected}
                    className={classes.input}
                    onChange={(e: any) => setSelected(e.target.value)}
                    defaultValue={selected}
                  >
                    <MenuItem value='register'>New Account Registeration</MenuItem>
                    <MenuItem value='password'>Update Password</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}
          />
          <Controller
            name='emails'
            control={control}
            render={({ field: { onChange, value }, fieldState: { invalid } }) => (
              <TextField
                className={classes.chipcolor}
                defaultValue={emails}
                id='standard-basic'
                placeholder='Enter comma seprated emails'
                label='Send Email To :'
                variant='standard'
                onChange={(e: any) => handleValidation(e)}
                error={!valid}
                helperText={!valid ? 'Please enter valid comma separated email address' : ' '}
                fullWidth
                multiline
              />
            )}
          />
          <Grid container justify='space-between' alignItems='center' className={classes.bottomBtn}>
            <Grid className={classes.block} container>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn1}
                  onClick={() => {
                    handleClose();
                  }}
                  fullWidth
                  variant='contained'
                  color='primary'
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn2}
                  type='submit'
                  fullWidth
                  variant='contained'
                  disabled={!valid}
                  color='secondary'
                >
                  Next
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      ) : (
        <p></p>
      )}

      {registrationStep === false ? (
        <form
          onSubmit={handleSubmit(onSubmit2)}
          className={classes.formContainer}
          style={{ maxHeight: '70vh', overflowY: 'auto' }}
        >
          <Grid>
            <Grid item container xs={12} className={classes.emailHeader}>
              <img src={headerlogo} alt='' />
            </Grid>
            <Grid className={classes.labels}>
              <p>Hello!</p>
            </Grid>
            {!getEmailTemplateReq.isLoading && emailtemp && emailtemp.length > 0 && (
              <Grid className={classes.details}>
                {emailtemp
                  .filter((template: any) => template.template === selected)
                  .map((template: any) => (
                    <React.Fragment key={template.id}>
                      {selected === 'register' ? (
                        <>
                          <Controller
                            name='templateSubjectReg'
                            control={control}
                            defaultValue={template.templateSubject}
                            rules={{ required: false }}
                            render={({ field, fieldState: { invalid } }) => (
                              <Grid container>
                                <TextField
                                  {...field}
                                  error={invalid}
                                  label='Subject'
                                  placeholder={template.templateSubject}
                                  defaultValue={template.templateSubject}
                                  helperText={invalid ? 'Required field' : ''}
                                  className={classes.input}
                                  multiline
                                  rows={2}
                                  InputProps={{ disableUnderline: true }}
                                />
                              </Grid>
                            )}
                          />
                          <Controller
                            name='templateBodyReg'
                            control={control}
                            defaultValue={template.templateBody}
                            rules={{ required: false }}
                            render={({ field, fieldState: { invalid } }) => (
                              <Grid container>
                                <div
                                  contentEditable
                                  dangerouslySetInnerHTML={{
                                    __html: replaceTemplateVariables(field.value || template.templateBody),
                                  }}
                                  onBlur={(e) => field.onChange(e.currentTarget.innerHTML)}
                                />
                              </Grid>
                            )}
                          />
                        </>
                      ) : (
                        <>
                          <Controller
                            name='templateSubjectPass'
                            control={control}
                            defaultValue={template.templateSubject}
                            rules={{ required: false }}
                            render={({ field, fieldState: { invalid } }) => (
                              <Grid container>
                                <TextField
                                  {...field}
                                  error={invalid}
                                  label='Subject'
                                  placeholder={template.templateSubject}
                                  defaultValue={template.templateSubject}
                                  helperText={invalid ? 'Required field' : ''}
                                  className={classes.input}
                                  multiline
                                  rows={2}
                                  InputProps={{ disableUnderline: true }}
                                />
                              </Grid>
                            )}
                          />
                          <Controller
                            name='templateBodyPass'
                            control={control}
                            defaultValue={template.templateBody}
                            rules={{ required: false }}
                            render={({ field, fieldState: { invalid } }) => (
                              <Grid container>
                                <div
                                  contentEditable
                                  dangerouslySetInnerHTML={{
                                    __html: replaceTemplateVariables(field.value || template.templateBody),
                                  }}
                                  onBlur={(e) => field.onChange(e.currentTarget.innerHTML)}
                                />
                              </Grid>
                            )}
                          />
                        </>
                      )}
                      <EmailHeader
                        ImageUrl={template.templateProfileImageUrl ?? ''}
                        EmailUrl={template.templateAdminEmail ?? ''}
                        OrganizationName={template.templateOrganizationName ?? ''}
                      />
                    </React.Fragment>
                  ))}
              </Grid>
            )}
          </Grid>
          <Grid container justify='space-between' alignItems='center' className={classes.bottomBtn1}>
            <Grid className={classes.block} container>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn1}
                  onClick={() => {
                    setRegistrationStep(true);
                    emailtemps(registrationStep);
                  }}
                  fullWidth
                  variant='contained'
                  color='primary'
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn2}
                  type='submit'
                  fullWidth
                  variant='contained'
                  color='secondary'
                  disabled={sendManualInvitationSteponeReq.isError}
                >
                  Confirm & send invite
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      ) : (
        <p></p>
      )}
    </>
  );
};
